import axios, { type InternalAxiosRequestConfig } from 'axios';
import makeAnalyticsInterceptor from '@carvana/stc-utilities/analyticsInterceptor/analyticsInterceptor';

type AxiosInterceptor = (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig;

const VERSION = process.env.APP_VERSION;
const TRADES_API = process.env.CARVANA_APP_TRADES_API;

const analyticsHeaders = () => {
  axios.interceptors.request.use(
    makeAnalyticsInterceptor({ allowedUrls: [TRADES_API], appVersion: VERSION }) as AxiosInterceptor
  );
};

if (typeof window !== 'undefined') {
  analyticsHeaders();
}
